import type { MappedCluster } from 'types'

// return it in reversed order to handle -1 returned from indexOf properly
const typeOrder = ['V', 'A', 'B', 'C'].reverse()

export function clusterSorterer(itemA: MappedCluster, itemB: MappedCluster) {
  const indexOfItemA = typeOrder.indexOf(itemA.type)
  const indexOfItemB = typeOrder.indexOf(itemB.type)
  return indexOfItemB - indexOfItemA
}
